import { createGlobalStyle } from 'styled-components'

type Page = 'login' | 'home' | 'faq' | 'profile' | 'report'

const backgroundColor = (page: Page) => {
  switch (page) {
    case 'login':
      return '#D82036'
    default:
      return '#fff'
  }
}

export const GlobalStyle = createGlobalStyle<{ page: Page }>`
  body {
    background: ${({ page }) => backgroundColor(page)};
    margin: 0;
    padding: 0;
  }

  .andlogo {
   position: relative;
    top: 6px;
    width: 93px;
    margin-right: 6px;
  }

  * {
    box-sizing: border-box;
    font-style: normal;
  }
`
export const DefaultFontStyle = `
  font-family: 'Poppins';
  font-style: normal;
`

export const DefaultBackground = `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(235, 235, 235, 0.93);
`
